<template>
	<div id="callLogReportFilter">
		<div class="datetimefilter">
			<div class="row pa-1 justify-sb datediv" hint="Date">
				<label>From</label>
				<div>
					<datetime class="theme-orange" type="datetime" format="yyyy-MM-dd HH:mm:ss"
						v-model="filter_fromdate" :value="filters.fromdate"></datetime>
				</div>
			</div>
			<div class="row pa-1 justify-sb datediv" hint="Date">
				<label>To</label>
				<div>
					<datetime class="theme-orange" type="datetime" format="yyyy-MM-dd HH:mm:ss" v-model="filter_todate">
					</datetime>
				</div>
			</div>
		</div>
		<v-text-field v-model="appliedfilter.phonenumber" :items="filter.phonenumber" label="Phone Number"
			persistent-hint small multiple single-line :allow-overflow="false">
		</v-text-field>
		<v-autocomplete v-model="appliedfilter.queue" :items="filterqueue" label="Queue" persistent-hint small multiple
			single-line :allow-overflow="false">
		</v-autocomplete>
		<v-autocomplete v-model="appliedfilter.agent" :items="filteragents" label="Agent" persistent-hint small multiple
			single-line :allow-overflow="false">
		</v-autocomplete>
		<v-text-field v-model="appliedfilter.extension" :items="filter.extension" label="Station" persistent-hint small
			multiple single-line :allow-overflow="false">
		</v-text-field>
		<v-text-field v-model="appliedfilter.uniqueid" :items="filter.uniqueid" label="Unique Id" persistent-hint small
			multiple single-line :allow-overflow="false">
		</v-text-field>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment'
export default {
	props: ['appliedfilter'],
	data() {
		return {
			page: {
				menu: {
					fromdate: false,
					todate: false
				}
			},
			filter_fromdate: '',
			filter_todate: '',
			filterqueue: [],
			filteragents: [],
		}
	},
	watch: {

		appliedfilter: {
			handler: function () {
				if (this.appliedfilter.fromdate == this.filters.fromdate && this.appliedfilter.todate == this.filters.todate) {
					this.date_flag = false
					this.filter_fromdate =  moment(this.appliedfilter.fromdate).format()
                    this.filter_todate = moment(this.appliedfilter.todate).format()
				}
			},
			deep: true
		},
		'filter_fromdate'(newVal) {
			var from_date = moment(newVal).format('YYYY-MM-DD HH:mm:ss');
			this.$store.commit('ACTION_FROMDATE', from_date);
			this.$store.commit('FILTERFROMDATE', from_date);
			// this.$emit("getDataFrom");
		},
		'filter_todate'(newVal) {
			var to_date = moment(newVal).format('YYYY-MM-DD HH:mm:ss');
			this.$store.commit('ACTION_TODATE', to_date);
			this.$store.commit('FILTER_TODATE', to_date);
			// this.$emit("getDataFrom");
		},
		'appliedfilter.phonenumber'(newVal) {
			this.$store.commit('FILTER_PHONE', { phone: newVal });
			// this.$emit("getDataFrom");
		},
		'appliedfilter.queue'(newVal) {
			this.$store.commit('FILTER_QUEUE', { queue: newVal });
			// this.$emit("getDataFrom");
		},
		'appliedfilter.agent'(newVal) {
			this.$store.commit('FILTER_AGENT', { agent: newVal });
			// this.$emit("getDataFrom");
		},
		'appliedfilter.extension'(newVal) {
			this.$store.commit('FILTER_EXTENSION', { extension: newVal });
			// this.$emit("getDataFrom");
		},
		'appliedfilter.uniqueid'(newVal) {
			this.$store.commit('FILTER_UNIQUEID', { uniqueid: newVal });
			// this.$emit("getDataFrom");
		}

	},
	computed: {
		...mapGetters([
			"filters",
			"filter",
			"queue"
		]),
	},
	mounted() {
		let current_time=moment(new Date()).format().split('T')[1].split('+')[0]
		// this.$store.dispatch('reportqueuelist');
		this.filterqueue = JSON.parse(localStorage.getItem("group_queue"));
		this.filteragents = JSON.parse(localStorage.getItem("group_users"));
		this.filter_fromdate = moment(this.filters.fromdate).format();
		this.filter_todate = moment(this.filters.todate).format();
		if(this.filters.fromdate.length==10 ||this.filters.todate.lenght==10){
        this.filter_fromdate = moment(this.filters.fromdate+' '+current_time).format();
        this.filter_todate = moment(this.filters.todate+' '+current_time).format();
        }

	},
	updated() {
		// this.$store.dispatch('reportqueuelist');
	},
} 
</script>

<style>
.theme-orange .vdatetime-popup__header,
.theme-orange .vdatetime-calendar__month__day--selected>span>span,
.theme-orange .vdatetime-calendar__month__day--selected:hover>span>span {
	background: #2196f3;
}

.theme-orange .vdatetime-year-picker__item--selected,
.theme-orange .vdatetime-time-picker__item--selected,
.theme-orange .vdatetime-popup__actions__button {
	color: #2196f3;
}
</style>